function initCarousel() {
  const slides = document.querySelectorAll('.product-media-constraint-wrapper');
  if (slides.length <= 1) return;

  // Éviter double initialisation
  if (document.querySelector('.carousel-dots')) return;

  let current = 0;
  let startX = 0;

  slides.forEach((slide, i) => {
    slide.style.display = i === 0 ? 'block' : 'none';
  });

  const dots = document.createElement('div');
  dots.className = 'carousel-dots';
  dots.style.cssText = 'display:flex;justify-content:center;gap:8px;padding:10px 0;';
  slides.forEach((_, i) => {
    const dot = document.createElement('span');
    dot.style.cssText = `width:8px;height:8px;border-radius:50%;background:${i===0?'#000':'#ccc'};cursor:pointer;display:inline-block;`;
    dot.addEventListener('click', () => goTo(i));
    dots.appendChild(dot);
  });
  slides[0].parentNode.appendChild(dots);
  document.querySelector('.slideshow-controls__dots')?.style.setProperty('display', 'none', 'important');


  function goTo(index) {
    slides[current].style.display = 'none';
    dots.children[current].style.background = '#ccc';
    current = index;
    slides[current].style.display = 'block';
    dots.children[current].style.background = '#000';
  }

  const container = document.querySelector('.product-media-container');
  container.addEventListener('touchstart', e => { startX = e.touches[0].clientX; });
  container.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0 && current < slides.length - 1) goTo(current + 1);
      if (diff < 0 && current > 0) goTo(current - 1);
    }
  });
}

// Attendre que tout soit chargé
if (document.readyState === 'complete') {
  initCarousel();
} else {
  window.addEventListener('load', initCarousel);
}
window.addEventListener('load', function() {
  const slideshow = document.querySelector('slideshow-component');
  if (!slideshow) return;

  let startX = 0;

  slideshow.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
  }, {passive: true});

  slideshow.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) < 50) return;

    if (diff > 0) {
      slideshow.querySelector('.slideshow-control--next')?.click();
    } else {
      slideshow.querySelector('.slideshow-control--previous')?.click();
    }
  }, {passive: true});
});
window.addEventListener('load', function() {
  if (window.innerWidth > 767) return;
  
  const container = document.querySelector('slideshow-container');
  const slides = document.querySelector('slideshow-slides');
  if (!container || !slides) return;

  // Force le scroll
  container.style.overflowX = 'scroll';
  container.style.scrollSnapType = 'x mandatory';
  slides.style.display = 'flex';
  slides.style.width = '100%';
  
  [...document.querySelectorAll('slideshow-slide')].forEach(slide => {
    slide.style.minWidth = '100%';
    slide.style.scrollSnapAlign = 'start';
  });

  let startX = 0;
  container.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
    e.stopPropagation();
  }, {passive: true});

  container.addEventListener('touchend', e => {
    e.stopPropagation();
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) < 50) return;
    const slideWidth = container.offsetWidth;
    container.scrollBy({left: diff > 0 ? slideWidth : -slideWidth, behavior: 'smooth'});
  }, {passive: true});
});
